<template>
  <address :class="'address' + (!hasClickEditListener ? ' address--no-padding' : '')">
    <div class="address__address-info">
      <p v-if="companyName" class="address__address-info__companyName">{{ companyName }}</p>
      <p v-if="name" class="address__address-info__name">
        {{ name }}
      </p>
      <p class="address__address-info__line1">{{ line1 }}</p>
      <p v-if="line2" class="address__address-info__line2">{{ line2 }}</p>
      <p class="address__address-info__city">{{ zip }} {{ city }}</p>
      <p class="address__address-info__country">{{ country }}</p>
      <p class="address__address-info__country" v-if="vatId">{{ vatId }}</p>
    </div>
    <div class="address__address-actions" v-if="hasClickEditListener">
      <m4-button tag="a" size="md" @click="onClickEditBtn" variant="primary-outline">
        {{ editBtnTitle }}
      </m4-button>
    </div>
  </address>
</template>

<script>
export default {
  name: "M4Address",
  props: {
    companyName: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    line1: {
      type: String,
      required: true
    },
    line2: {
      type: String,
      required: false
    },
    zip: {
      type: String,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    country: {
      type: String,
      required: false
    },
    vatId: {
      type: String
    },
    editBtnTitle: {
      type: String,
      default() {
        return "Edit Address";
      }
    },
    onOnClickEdit: Function
  },
  emits: ["onClickEdit"],
  computed: {
    hasClickEditListener() {
      return typeof this.$props.onOnClickEdit === "function" || typeof this.$attrs.onOnclickedit === "function";
    }
  },
  methods: {
    onClickEditBtn() {
      this.$emit("onClickEdit");
      this.$emit("onclickedit"); //ugly fix
    }
  }
};
</script>
